import { escapeHtml as esc } from '../../../core/ui/escapeHtml.js';

function iconStarHeader() {
  return `<svg class="h-5 w-5 text-amber-500" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.4 7.4h7.6l-6 4.6 2.3 7-6-4.6-6 4.6 2.3-7-6-4.6h7.6z" /></svg>`;
}

function iconChevron(extraClass = 'text-slate-400') {
  return `<svg class="h-5 w-5 shrink-0 ${extraClass}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>`;
}

const RX_UID = /^[A-Za-z0-9_-]{10,128}$/;

/**
 * @param {object} opts
 * @param {(uid: string) => void} [opts.onOpenPerfilVendedorUid]
 * @param {(productoId: string) => void} [opts.onOpenProductoDetalle]
 * @param {string} [opts.negocioFotoPerfilUrl] foto Storage `usuarios/{uid}/perfil.webp`
 */
export function pintarBloquesPublicidadHome(opts) {
  const {
    wrapEl,
    negocioEl,
    destacadosEl,
    comerciosEl,
    negocio,
    destacadosItems,
    comerciosRows,
    onOpenPerfilVendedorUid,
    onOpenProductoDetalle,
    negocioFotoPerfilUrl = '',
  } = opts;

  const hasSomething =
    Boolean(negocio) ||
    (destacadosItems && destacadosItems.length > 0) ||
    (comerciosRows && comerciosRows.length > 0);
  if (!wrapEl) return;
  wrapEl.classList.toggle('hidden', !hasSomething);

  if (!negocioEl) {
    /* skip */
  } else if (!negocio) {
    negocioEl.innerHTML = '';
  } else {
    const fotoPerfil = String(negocioFotoPerfilUrl || '').trim();
    const imgHero = String(negocio.imagen_url || '').trim();
    const img = imgHero || fotoPerfil;
    const avatarSrc = fotoPerfil || imgHero;
    const desc = String(negocio.subtitulo || negocio.descripcion || '').trim();
    const uidNegBtn = String(negocio.vendedor_uid || '').trim();
    const uidBtnOk = RX_UID.test(uidNegBtn);
    const titIni = String(negocio.titulo || '').trim().slice(0, 1).toUpperCase() || '?';
    const avatarCircle = avatarSrc
      ? `<div class="pointer-events-none absolute right-2 top-2 h-16 w-16 overflow-hidden rounded-full border-2 border-amber-400/40 bg-amber-400/10 shadow-md ring-1 ring-white/20"><img src="${esc(avatarSrc)}" alt="" class="h-full w-full object-cover" loading="lazy" /></div>`
      : `<div class="pointer-events-none absolute right-2 top-2 flex h-16 w-16 items-center justify-center rounded-full border-2 border-amber-400/50 bg-amber-950/55 text-lg font-black text-white shadow-md ring-1 ring-white/25" aria-hidden="true">${esc(titIni)}</div>`;
    const uidAttr = uidBtnOk ? ` data-ad-negocio-uid="${esc(uidNegBtn)}"` : '';
    negocioEl.innerHTML = `
      <article id="cat-ad-negocio-card" class="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#003d40] via-brand-primary to-[#004d4d] p-5 text-white shadow-lg ring-1 ring-amber-500/30 bg-cover bg-center">
        ${avatarCircle}
        <p class="inline-block rounded-lg bg-amber-500/95 px-2.5 py-1 text-[10px] font-black uppercase tracking-widest text-slate-900 shadow-sm">Negocio del día</p>
        <h3 class="font-heading mt-3 text-xl font-bold leading-tight">${esc(negocio.titulo)}</h3>
        ${desc ? `<p class="mt-2 text-sm leading-relaxed text-white/88">${esc(desc)}</p>` : ''}
        <div class="mt-4 flex justify-end">
          <button type="button" data-ad-negocio-btn="1"${uidAttr} class="rounded-xl bg-brand-secondary px-4 py-2.5 text-xs font-bold uppercase tracking-wide text-emerald-950 shadow-md transition hover:brightness-95">
            Ver perfil de ventas
          </button>
        </div>
      </article>`;
    const card = negocioEl.querySelector('#cat-ad-negocio-card');
    if (card && img) {
      card.style.backgroundImage = `linear-gradient(105deg,rgba(0,32,34,0.92) 0%,rgba(0,77,77,0.55) 45%,rgba(0,0,0,0.25) 100%), url(${JSON.stringify(img)})`;
    }
    const btn = negocioEl.querySelector('[data-ad-negocio-btn]');
    if (btn && uidBtnOk) {
      btn.onclick = () => {
        const u = (btn.getAttribute('data-ad-negocio-uid') || '').trim();
        if (RX_UID.test(u)) onOpenPerfilVendedorUid?.(u);
      };
    } else if (btn) {
      btn.disabled = true;
    }
  }

  if (!destacadosEl) {
    /* skip */
  } else if (!destacadosItems?.length) {
    destacadosEl.innerHTML = '';
  } else {
    destacadosEl.innerHTML = `
      <div class="mb-2 flex items-center justify-between gap-2">
        <div class="flex items-center gap-2">
          ${iconStarHeader()}
          <h3 class="font-heading text-base font-bold text-slate-900">Destacados del barrio</h3>
        </div>
      </div>
      <div class="grid grid-cols-2 items-stretch gap-3">
        ${destacadosItems
          .map((row) => {
            const tit = String(row.titulo || '').trim() || 'Destacado';
            const sub = String(row.subtitulo || '').trim();
            const uid = String(row.vendedor_uid || '').trim();
            const uidOk = RX_UID.test(uid);
            const pid = String(row.producto_id || '').trim();
            const img = String(row.imagen_url || '').trim();
            const imgBlock = img
              ? `<img src="${esc(img)}" alt="" class="absolute inset-0 h-full w-full object-cover" loading="lazy" />`
              : `<div class="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-brand-primary/20 to-brand-primary/5 text-2xl font-bold text-brand-primary">${esc(tit.slice(0, 1).toUpperCase())}</div>`;
            const ctaLabel = pid ? 'Ver publicación' : 'Ver ventas';
            const enabled = pid || uidOk;
            return `
          <div class="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-sm ring-1 ring-slate-100">
            <div class="relative h-40 w-full shrink-0 overflow-hidden bg-slate-100 sm:h-44">
              ${imgBlock}
              <span class="absolute left-2 top-2 z-[1] rounded-md bg-amber-500 px-2 py-0.5 text-[9px] font-black uppercase tracking-wide text-white shadow-sm">Promo</span>
            </div>
            <div class="flex min-h-0 flex-1 flex-col justify-between gap-2 p-2.5 pt-2">
              <div class="shrink-0">
                <p class="line-clamp-2 text-xs font-bold leading-snug text-slate-900">${esc(tit)}</p>
                ${sub ? `<p class="mt-1 line-clamp-2 text-[10px] text-slate-600">${esc(sub)}</p>` : ''}
              </div>
              <button type="button" data-ad-dest-uid="${esc(uid)}" data-ad-dest-product="${esc(pid)}" class="w-full shrink-0 rounded-xl py-2 text-xs font-bold shadow-sm transition ${enabled ? 'bg-brand-primary text-white hover:brightness-95' : 'cursor-not-allowed bg-slate-200 text-slate-500'}" ${enabled ? '' : 'disabled'}>
                ${esc(ctaLabel)}
              </button>
            </div>
          </div>`;
          })
          .join('')}
      </div>`;
    destacadosEl.querySelectorAll('[data-ad-dest-uid]').forEach((btn) => {
      const pid = (btn.getAttribute('data-ad-dest-product') || '').trim();
      const u = (btn.getAttribute('data-ad-dest-uid') || '').trim();
      if (btn.disabled) return;
      btn.onclick = () => {
        if (pid) onOpenProductoDetalle?.(pid);
        else if (RX_UID.test(u)) onOpenPerfilVendedorUid?.(u);
      };
    });
  }

  if (!comerciosEl) {
    /* skip */
  } else if (!comerciosRows?.length) {
    comerciosEl.innerHTML = '';
  } else {
    comerciosEl.innerHTML = `
      <h3 class="font-heading mb-3 text-base font-bold text-slate-900">Comercios del barrio</h3>
      <ul class="space-y-2.5">
        ${comerciosRows
          .map((row, i) => {
            const titulo = String(row.titulo || '').trim();
            const sub = String(row.subtitulo || '').trim();
            const bgImg = String(row.imagen_url || '').trim();
            const fotoPerfil = String(row.foto_perfil_url || '').trim();
            const tags = Array.isArray(row.etiquetas) ? row.etiquetas : [];
            const uidCta = String(row.vendedor_uid || '').trim();
            const uidBtnOk = RX_UID.test(uidCta);
            const hasBg = Boolean(bgImg);
            const titIni = titulo.slice(0, 1).toUpperCase() || '?';
            const thumb = fotoPerfil
              ? `<img src="${esc(fotoPerfil)}" alt="" class="relative z-[1] h-14 w-14 shrink-0 rounded-xl border-2 border-white object-cover shadow-md" loading="lazy" />`
              : `<div class="relative z-[1] flex h-14 w-14 shrink-0 items-center justify-center rounded-xl border-2 border-white bg-brand-muted text-xs font-bold text-brand-primary shadow-md">${esc(titIni)}</div>`;
            const tagsHtml = tags
              .slice(0, 3)
              .map(
                (t) =>
                  hasBg ?
                    `<span class="inline-block rounded-md bg-white/20 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-white/95">${esc(String(t))}</span>`
                  : `<span class="inline-block rounded-md bg-slate-100 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-slate-600">${esc(String(t))}</span>`
              )
              .join(' ');
            const btnBase =
              `relative flex w-full items-center gap-3 overflow-hidden rounded-2xl p-2.5 text-left shadow-sm transition ${uidBtnOk ? '' : 'cursor-not-allowed opacity-70'}`;
            const btnLight = `${btnBase} border border-slate-200/90 bg-white ${uidBtnOk ? 'hover:bg-slate-50/90' : ''}`;
            const btnOnImg = `${btnBase} border border-white/25 ${uidBtnOk ? 'hover:brightness-[1.03]' : ''}`;
            const uidAttr = uidBtnOk ? ` data-ad-comercio-uid="${esc(uidCta)}"` : '';
            const bgData = hasBg ? ` data-ad-comercio-bg="${encodeURIComponent(bgImg)}"` : '';
            return `
          <li>
            <button type="button" data-ad-comercio-idx="${i}" data-ad-comercio-card="1"${uidAttr} class="${hasBg ? btnOnImg : btnLight}" ${uidBtnOk ? '' : 'disabled'}>
              ${
                hasBg ?
                  `<span class="pointer-events-none absolute inset-0"${bgData} aria-hidden="true"></span>
              <span class="pointer-events-none absolute inset-0" style="background:linear-gradient(90deg,rgba(15,23,42,0.88) 0%,rgba(15,23,42,0.55) 45%,rgba(15,23,42,0.35) 100%)" aria-hidden="true"></span>`
                : ''
              }
              ${thumb}
              <div class="relative z-[1] min-w-0 flex-1">
                <p class="truncate text-sm font-bold ${hasBg ? 'text-white' : 'text-slate-900'}">${esc(titulo)}</p>
                ${sub ? `<p class="mt-0.5 line-clamp-2 text-[11px] ${hasBg ? 'text-white/85' : 'text-slate-500'}">${esc(sub)}</p>` : ''}
                ${tagsHtml ? `<div class="mt-1.5 flex flex-wrap gap-1">${tagsHtml}</div>` : ''}
              </div>
              <span class="relative z-[1] shrink-0">${iconChevron(hasBg ? 'text-white/75' : 'text-slate-400')}</span>
            </button>
          </li>`;
          })
          .join('')}
      </ul>`;
    comerciosEl.querySelectorAll('[data-ad-comercio-bg]').forEach((el) => {
      const enc = el.getAttribute('data-ad-comercio-bg');
      if (!enc) return;
      try {
        const u = decodeURIComponent(enc);
        el.style.backgroundSize = 'cover';
        el.style.backgroundPosition = 'center';
        el.style.backgroundImage = `url(${JSON.stringify(u)})`;
      } catch (_e) {
        /* ignore */
      }
    });
    comerciosEl.querySelectorAll('[data-ad-comercio-uid]').forEach((btn) => {
      if (btn.disabled) return;
      btn.onclick = () => {
        const u = (btn.getAttribute('data-ad-comercio-uid') || '').trim();
        if (RX_UID.test(u)) onOpenPerfilVendedorUid?.(u);
      };
    });
  }
}
